export default __webpack_public_path__ + "static/media/postcardsPreview.07aa5cf4.webp";